import { render, staticRenderFns } from "./checkboxTable2.vue?vue&type=template&id=2979a3c2&scoped=true"
import script from "./checkboxTable2.vue?vue&type=script&lang=js"
export * from "./checkboxTable2.vue?vue&type=script&lang=js"
import style0 from "./checkboxTable2.vue?vue&type=style&index=0&id=2979a3c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2979a3c2",
  null
  
)

export default component.exports